module.exports = __webpack_public_path__ + "img/CH01-040-041.09ff9c05.jpg";